export default __webpack_public_path__ + "images/multiple-airline.1c82c40.png";